import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const ModalDescription = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: classNames("text-14 text-grey-11", className),
        ...restOfProps
    });
};
